// extracted by mini-css-extract-plugin
module.exports = {"container":"Header_container_2yXIl","wrap":"Header_wrap_2HdqQ","logo":"Header_logo_1jnTh","title":"Header_title_3qYqb"};